import { FormattedMessage } from "react-intl";

import { classNames } from "helpers/commonHelpers";
import { getPodStatusMessageId, PodStatus } from "./podStatus";

export type MasterPodRowProps = Readonly<{
  status: PodStatus;
  testId: string;
  onSelect?: () => void;
}>;

const STATUS_DEFAULT_MESSAGES: Record<PodStatus, string> = {
  pending: "No POD yet",
  partial: "Partial POD",
  delivered: "Delivered",
};

export default function MasterPodRow({ status, testId, onSelect }: MasterPodRowProps) {
  return (
    <button
      type="button"
      role="menuitem"
      className="proof-of-delivery-menu__row"
      data-testid={testId}
      onClick={() => onSelect?.()}
    >
      <span className="proof-of-delivery-menu__row-content">
        <span className="proof-of-delivery-menu__row-header">
          <span className="proof-of-delivery-menu__master-label">
            <FormattedMessage id="components.molecules.top-nav.masterPod" defaultMessage="Master POD" />
          </span>
          <span
            className={classNames("proof-of-delivery-menu__status", {
              "proof-of-delivery-menu__status--pending": status === "pending",
              "proof-of-delivery-menu__status--partial": status === "partial",
              "proof-of-delivery-menu__status--delivered": status === "delivered",
            })}
          >
            <FormattedMessage id={getPodStatusMessageId(status)} defaultMessage={STATUS_DEFAULT_MESSAGES[status]} />
          </span>
        </span>
      </span>
    </button>
  );
}
